<template>
  <div class="select-wrap">
    <div class="input_wrap" @click="open">
      <span class="input_title">频率：</span>
      <div class="input_row alignr">
        {{
          herbFrequence ? getKeyValueText('chinese_drug_frequence_his', herbFrequence) : '请选择'
        }}
      </div>
    </div>
    <!-- 修改频率弹框 -->
    <uni-popup ref="herbFrequenceRef" type="bottom">
      <div class="btn_row">
        <div class="confirm_btn" @click="confirmHerbFrequence">
          <span>确认</span>
        </div>
      </div>
      <picker-view
        class="picker-view"
        :value="[selectHerbFrequence]"
        @change="onChangeHerbFrequence"
      >
        <picker-view-column>
          <div v-for="(item, index) in herbFrequenceList" :key="index" class="item">
            {{ item.value }}
          </div>
        </picker-view-column>
      </picker-view>
    </uni-popup>
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
export default {
  name: 'MsFrequency',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      getKeyValueText,
      herbFrequence: '', // 频率
      selectHerbFrequence: 0 // 在列表中选中的值
    }
  },
  watch: {
    modelValue: {
      handler() {
        // value变化更新初始值
        this.herbFrequence = this.initDefaultVal()
      },
      immediate: true
    },
    herbFrequenceList: {
      handler() {
        // 备选列表变化更新初始值
        this.herbFrequence = this.initDefaultVal()
      },
      immediate: true
    }
  },
  computed: {
    herbFrequenceList() {
      let keyValue = {}
      if (localStorage.getItem('keyValue')) {
        keyValue = JSON.parse(localStorage.getItem('keyValue'))
      }
      if (this.$store.state.keyValue) {
        keyValue = this.$store.state.keyValue
      }
      return keyValue['chinese_drug_frequence_his'] || []
    }
  },
  methods: {
    // 更新初始值
    initDefaultVal() {
      // 没有备选列表传入什么就展示什么
      if (!this.herbFrequenceList || !this.herbFrequenceList.length) {
        return this.modelValue
      }
      // 有备选列表没有传入值，默认选中第一个
      if (!this.modelValue) {
        this.$emit('update:modelValue', this.herbFrequenceList[0].code)
        return this.herbFrequenceList[0].code
      }
      const target = this.herbFrequenceList.find(
        item => item.code === this.modelValue || item.value === this.modelValue
      )
      // 有备选列表&有传入值，传入的值在备选列表中没查到默认选中第一个
      if (!target) {
        this.$emit('update:modelValue', this.herbFrequenceList[0].code)
        return this.herbFrequenceList[0].code
      }
      this.$emit('update:modelValue', target.code)
      // 更新备选列表中选中值
      this.selectHerbFrequence = this.herbFrequenceList.findIndex(
        item => item.code === this.modelValue || this.modelValue === item.value
      )
      // 有备选列表&有传入值，默认选中传入值
      return target.code
    },
    open() {
      // 打开频率备选列表
      this.$refs.herbFrequenceRef.open()
    },
    close() {
      // 关闭频率备选列表
      this.$refs.herbFrequenceRef.close()
    },
    onChangeHerbFrequence(e) {
      // 更新频率值, 获取到的是列表索引值,需要转换成对应的code值
      const index = e.detail.value[0] || 0
      this.selectHerbFrequence = index
    },
    confirmHerbFrequence() {
      // 更新选中的值到父组件
      const target = this.herbFrequenceList[this.selectHerbFrequence] || {}
      this.$emit('update:modelValue', target.code || '')
      //   关闭备选列表
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-wrap {
  .input_wrap {
    display: flex;
    padding: 0 0.682667rem 0 0.682667rem;
    align-items: center;
    justify-content: space-between;
    height: 2.005333rem;
    border-top: 0.021333rem solid #ececec;

    .input_row {
      display: flex;
      width: 3.626667rem;
      height: 100%;
      align-items: center;
      .input_con {
        text-align: right;
      }
      .unit {
        margin-left: 0.213333rem;
      }
      &.alignr {
        justify-content: flex-end;
      }
    }
  }
}
.btn_row {
  display: flex;
  width: 100%;
  background-color: #fff;
  justify-content: space-between;
  .delete_btn,
  .confirm_btn {
    height: 1.706667rem;
    background-color: #fff;
    padding: 0 0.853333rem;
    line-height: 2.56rem;
    color: #2772ff;
  }
}
::v-deep.picker-view {
  height: 10.666667rem;
  background: #fff;
  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 1.066667rem;
  }
}
</style>
